// extracted by mini-css-extract-plugin
module.exports = {"step":"iwP0gb","detailedStep":"Zo9T48","title":"_1Snp_B","desc":"AERX86","options":"_1-81p_","shine-lines":"edU77m"};